// extracted by mini-css-extract-plugin
export default {"priceBreakdownInfo":"PriceBreakdownInfo_priceBreakdownInfo__KPYky","row":"PriceBreakdownInfo_row__0Xi6m","priceBreakdown":"PriceBreakdownInfo_priceBreakdown__sN2nv"};